import { FormGroup, Box, InputAdornment, Button, Chip } from "@mui/material";
import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import BSSForm from "../../../form/BSSForm";
import BSSText from "../../../form/BSSText";
import { DefaultSubmitErrorHandler } from "../../../preventivo/Preventivo";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { Search, MoreVert } from "@mui/icons-material";
import { lighten } from "@mui/material";
import { filterToDate } from "./DialogFiltroData";
import MenuFiltri from "./MenuFiltri";
import FiltriAttivi from "./FiltriAttivi";
const {logger} = useBSSLogger();


const mappaOperatoriComparazione = {
    eq: "=",
    ne: "<>",
    lt: "<",
    lte: "<=",
    gt: ">",
    gte: ">="
}

const almenoUnFiltro = (filtri)  => Object.entries(filtri.filtriRicerca ?? {})
    .find(([k, v]) => {
        let esito = v !== null;
        if(["stati", "tipispedizione", "campiRicerca"].includes(k) && v !== null) {
            esito = Array.isArray(v) && v.length !== 0
        } else if(k === "operatore") {
            esito = false;
        } 
        logger.debug("esito almeno un filtro", k, v, esito)
        return esito;
    }) ?? false;

const FiltriOrdini = ({filtri, setFiltri, stati, tipispedizione, campiRicerca}) => {

    const methods = useForm({
        defaultValues: {
            term: ""
        }
    })
    const {handleSubmit} = methods;
    
    const [menuFiltri, setMenuFiltri] = useState({anchorEl: null, open: false})

    const onSubmit = async (data) => {

        let nuoviFiltri = null;
        const {term} = data;

        if(![null, undefined, ''].includes(term)){
            nuoviFiltri = {                
                term
            }
        }
        setFiltri({
            ...filtri, 
            filtriRicerca: {
                ...filtri.filtriRicerca,
                ...nuoviFiltri
            }, 
            skip: 0
        });
        methods.reset();

    }   


    return (
        <>            
            <FormProvider {...methods}>
                <BSSForm onEnterSubmit onSubmit={handleSubmit(onSubmit, DefaultSubmitErrorHandler)}>      
                    
                        
                            <FormGroup row>
                                <Box width={1} mb={1.2}>
                                    <BSSText
                                        name={`term`} 
                                        label={__t("cercaordini")}    
                                        methods={methods}          
                                        TextFieldInputProps={{
                                            sx: {
                                                paddingRight: "0px",
                                                paddingLeft: "0px"
                                            },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <MoreVert color="primary" sx={{cursor: "pointer"}} onClick={e => setMenuFiltri({anchorEl: e.currentTarget, open: true})} />
                                                                                                        
                                                    <MenuFiltri stati={stati} menuFiltri={menuFiltri} setMenuFiltri={setMenuFiltri} filtri={filtri} setFiltri={setFiltri} tipispedizione={tipispedizione} campiRicerca={campiRicerca} />

                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    <Button variant="contained" type={"submit"} sx={{
                                                        minWidth: 0,
                                                        paddingX: 1

                                                    }}>
                                                        <Search />
                                                    </Button>
                                                </InputAdornment>
                                            )
                                        }}                                                                                                          
                                    />
                                </Box>                                

                                <Box width={1} mb={1.2} sx={{textAlign: "right"}}>
                                    <FiltriAttivi filtri={filtri} setFiltri={setFiltri} campiRicerca={campiRicerca} stati={stati} tipispedizione={tipispedizione} />
                                </Box>
                                
                            </FormGroup>
                        
                </BSSForm>
            </FormProvider>
        </>
    )

}




export default FiltriOrdini;
export {almenoUnFiltro, mappaOperatoriComparazione}